export default __webpack_public_path__ + "static/media/cross-admin-icon.d123671d.svg";